<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table
        :data="productDetailInventoryInfo.orders"
        border
        style="width: 100%"
        size="small"
      >
        <el-table-column prop="productId" label="编号" align="center" />
        <el-table-column prop="prodName" label="名称" align="center" />
        <el-table-column prop="specName" label="规格" align="center" />
        <el-table-column prop="price" label="单价" align="center" />
        <el-table-column prop="quantity" label="账面数量" align="center" />
        <el-table-column prop="invQuantity" label="盘点数量" align="center" />
        <el-table-column prop="willExpire" label="将过期" align="center" />
        <el-table-column prop="attrition" label="耗损" align="center" />
        <el-table-column prop="invProfit" label="盘盈" align="center" />
        <el-table-column prop="invLoss" label="盘亏" align="center" />
        <el-table-column prop="invProfitMoney" label="盘盈金额" align="center" />
        <el-table-column prop="invLossMoney" label="盘亏金额" align="center" />
        <el-table-column prop="stateName" label="状态" align="center" />
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next"
            :total="pagination.total"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryInoutOrderProduct } from '@/api/goods/productDetailApi'

export default {
  name: 'ProductDetailInventory',
  data() {
    return {
      productDetailInventoryInfo: {
        orders: [],
        productId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.productDetailInventoryInfo.productId = params.productId
      this.loadProductDetailInventoryData()
    },
    async loadProductDetailInventoryData() {
      const res = await queryInoutOrderProduct({
          productId: this.productDetailInventoryInfo.productId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          shopId: getShopId()
      })
      this.productDetailInventoryInfo.orders = res.data
      this.pagination.total = res.records
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadProductDetailInventoryData()
    },
    computeInventoryData(inoutOrderProduct) {
      inoutOrderProduct.invProfit = parseInt(inoutOrderProduct.invQuantity) - parseInt(inoutOrderProduct.quantity)
      if (inoutOrderProduct.invProfit < 0) {
        inoutOrderProduct.invProfit = 0
      }
      inoutOrderProduct.invLoss = parseInt(inoutOrderProduct.quantity) - parseInt(inoutOrderProduct.invQuantity)
      if (inoutOrderProduct.invLoss < 0) {
        inoutOrderProduct.invLoss = 0
      }
      inoutOrderProduct.invProfitMoney = inoutOrderProduct.invProfit * parseFloat(inoutOrderProduct.price)
      inoutOrderProduct.invLossMoney = inoutOrderProduct.invLoss * parseFloat(inoutOrderProduct.price)
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>